import axios from 'axios';
import store from '../store/store';
import cacheManager from '../store/CacheManager';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use(function (config) {
    const appState = store.getState();
    if (appState && appState.userSession && appState.userSession.sessionToken) {
        config.headers['app-authorization'] = appState.userSession.sessionToken;
    }
    config.params = config.params || {};
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    const resData = response.data;
    cacheManager.hydrate(resData.resource);
    return response;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default instance;